const buildForCustomers = true;
let pathRoot = "";
if (process.env.NODE_ENV === "production"){
  if(!buildForCustomers) {
    pathRoot = "/simulator"
  }
}

export default [
  {
    path: pathRoot + '',
    name: 'ModuleA',
    component: () => import(/* webpackChunkName: "ModuleA" */ './views'),
    meta: {
      order: 0,
    },
    children:[
      {
        path: pathRoot + '/step1',
        name: 'Step1',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step1.vue'),
        meta: {
          order: 1,
        }
      },
      {
        path: pathRoot + '/step2',
        name: 'Step2',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step2.vue'),
        meta: {
          order: 2,
        }
      },
      {
        path: pathRoot + '/step3',
        name: 'Step3',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step3.vue'),
        meta: {
          order: 3,
        }
      },
      {
        path: pathRoot + '/step4',
        name: 'Step4',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step4.vue'),
        meta: {
          order: 4,
        }
      },
      {
        path: pathRoot + '/step5',
        name: 'Step5',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step5.vue'),
        meta: {
          order: 5,
        }
      },
      {
        path: pathRoot + '/step6',
        name: 'Step6',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step6.vue'),
        meta: {
          order: 6,
        }
      },
      {
        path: pathRoot + '/step7',
        name: 'Step7',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step7.vue'),
        meta: {
          order: 7,
        }
      },
      {
        path: pathRoot + '/step8',
        name: 'Step8',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step8.vue'),
        meta: {
          order: 8,
        }
      },
      {
        path: pathRoot + '/step9',
        name: 'Step9',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step9.vue'),
        meta: {
          order: 9,
        }
      },
      {
        path: pathRoot + '/step10',
        name: 'Step10',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step10.vue'),
        meta: {
          order: 10,
        }
      },
      {
        path: pathRoot + '/step11',
        name: 'Step11',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Step11.vue'),
        meta: {
          order: 11,
        }
      },
      {
        path: pathRoot + '/form',
        name: 'Form',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/Form.vue'),
        meta: {
          order: 12,
        }
      },
      {
        path: pathRoot + '/thankyou',
        name: 'ThankYou',
        component: () => import(/* webpackChunkName: "ModuleA" */ './views/ThankYou.vue'),
        meta: {
          order: 13,
        }
      },
    ]
  }
]
